import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPw = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#09F", d: "M0 0h16v10H0z" }), /* @__PURE__ */ React.createElement("circle", { fill: "#FF0", cx: 7, cy: 5, r: 3 }));
const ForwardRef = forwardRef(SvgPw);
const Memo = memo(ForwardRef);
export default Memo;
